<template>
<div class="DeviceListsGas">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <el-input class="common" placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable>
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-button
            class="common"
            type="primary"
            size="medium"
            @click="serachData"
            icon="el-icon-search">搜索</el-button>
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix device-cardList">
              <li v-for="(item,index) in dataList" :key="index" :class="['device-card', item.isOnline == '离线' ?'outItem':'']">
                <h6>
                  <span class="title overText">{{item.name}}</span>
                  <div class="title-right">
                    <!-- <span class="sign-num" v-if="item.isOnline != '离线'">{{item.csq}}%</span> -->
                    <!-- 信号值 -->
                    <img class="sign" src="../../assets/img/bigScreen/sign-0.png" alt="" v-if="item.isOnline == '离线'">
                    <img class="sign" :src="signImg(item.sign)" alt="" v-else>
                    <!-- 电量 -->
                    <span>{{item.batteryPercentage}}%</span>
                    <span class="electric">
                      <i :class="item.batteryPercentage <= 20 ? 'red':''" :style="{width: item.batteryPercentage + '%'}"></i>
                      <img v-if="item.isOnline == '离线'" src="../../assets/img/devicetype/electric-gray.png" alt="" />
                      <img v-else-if="item.batteryPercentage <= 20" src="../../assets/img/devicetype/electric-red.png" alt="" />
                      <img v-else src="../../assets/img/devicetype/electric.png" alt="" />
                    </span>
                    <!-- 详情按钮 -->
                    <span class="set" @click="clickEven(item)">
                      <i class="el-icon-edit-outline"></i>
                    </span>
                    <!-- 设置按钮 -->
                    <span class="set" @click="handleClickSet(item)" v-if="item.typeName != 'LT_生命体征雷达'">
                      <i class="el-icon-s-tools"></i>
                    </span>
                  </div>
                </h6>
                <div class="chart-item">
                  <div class="chart">
                    <div class="top-title-box" ref="titleC" >
                      <p  class="top-title" v-if="item.isOnline == '离线'">
                        离线中
                      </p>
                      <p  class="top-title" style="background: #EE211C" v-else-if="item.isAlarm == '报警中'">
                        报警中
                      </p>
                      <!-- 启用 -->
                      <template v-else-if="item.typeName == 'LT_生命体征雷达' || item.typeName == 'LT_跌倒雷达'">
                        <!-- 活跃： item.motionAlarmStateType == '1' && item.radarState == 2 -->
                        <!-- 无人： item.motionAlarmStateType == '2' && item.radarState == 0 -->
                        <p
                          class="top-title" 
                          style="background: #EE211C"
                          v-if="(item.motionAlarmStateType == '1' && item.radarState == 2) || (item.motionAlarmStateType == '2' && !item.radarState)">
                          <span v-if="item.motionAlarmStateType == '1' && item.radarState == 2">活跃</span>
                          <span v-if="item.motionAlarmStateType == '2' && item.radarState == 0">无人</span>
                        </p>
                        <!-- 驻留： item.stopStateType == '1' && item.stopState == true -->
                        <!-- 未驻留： item.stopStateType == '2' && item.stopState == false -->
                        <p
                          class="top-title"
                          style="background: #EE211C"
                          v-if="(item.stopStateType == '1' && item.stopState)||(item.stopStateType == '2' && !item.stopState)">
                          <!-- <img src="../../assets/img/deviceRadar/state.png" alt=""> -->
                          <span v-if="item.stopStateType == '1' && item.stopState">驻留</span>
                          <span v-if="item.stopStateType == '2' && !item.stopState">未驻留</span>
                        </p>
                        <!-- 跌倒： item.fallState -->
                        <p class="top-title" style="background: #EE211C" v-if="item.fallState">
                          <!-- <img src="../../assets/img/deviceRadar/fall.png" alt=""> -->
                          <span>跌倒</span>
                        </p>
                        <p class="top-title" style="background: #4CC790" v-if="item.isAlarm == '正常'">
                          <span>监测中</span>
                        </p>
                      </template>
                      <!-- 未启用 -->
                      <p class="top-title" style="background: #aaa" v-else>
                        <!-- <img src="../../assets/img/deviceRadar/no.png" alt=""> -->
                        <span>未启用</span>
                      </p>
                    </div>
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-if="item.typeName == 'LT_跌倒雷达' && item.isOnline == '离线'" src="../../assets/img/deviceRadar/gray.png" alt="">
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-else-if="item.typeName == 'LT_生命体征雷达' && item.isOnline == '离线'" src="../../assets/img/deviceRadar/gray1.png" alt="">
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-else-if="item.typeName == 'LT_跌倒雷达' && item.isAlarm == '报警中'" src="../../assets/img/deviceRadar/red.png" alt="">
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-else-if="item.typeName == 'LT_生命体征雷达' && item.isAlarm == '报警中'" src="../../assets/img/deviceRadar/red1.png" alt="">
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-else-if="item.typeName == 'LT_跌倒雷达' && item.isOnline == '在线'" src="../../assets/img/deviceRadar/blue.png" alt="">
                    <img :class="item.typeName == 'LT_生命体征雷达' ? 'sizeImg' : ''" v-else src="../../assets/img/deviceRadar/blue1.png" alt="">
                    <p class="state" :style="{ color: item.isOnline == '离线' ? '#aaa' : '#4CC790'}">{{item.isOnline}}</p>
                    <div class="switch-box">
                      <span  class="set" @click="handleSet(false, index, item)">撤防</span>
                      <span  class="set" @click="handleSet(true, index, item)">布防</span>
                      <span
                        class="active"
                        :style="{ background: item.deviceRemoval == false ? '#EE211C' : '#4CC790', left: item.deviceRemoval == false ? '0' : '48px'}"
                        :ref="`active${index}`">
                        {{item.deviceRemoval == false ? "撤防" : "布防"}}
                      </span>
                    </div>
                  </div>

                  <div class="device-params">
                    <div>
                        <p class="params-t">{{item.typeName == 'LT_跌倒雷达' ? '位置' : 'IMEI'}}</p>
                        <el-tooltip effect="light" :content="item.installLocation" placement="right">
                          <p class='overText address-overtext'>{{item.typeName == 'LT_跌倒雷达' ? item.installLocation : item.imei || '--'}}</p>
                        </el-tooltip>
                    </div>
                    <div>
                      <p class="params-t">{{item.typeName == 'LT_跌倒雷达' ? 'IMEI' : '呼吸率'}}</p>
                      <p class='overText'>{{item.typeName == 'LT_跌倒雷达' ? item.imei : item.breathingRate + '次/分' || '--'}}</p>
                    </div>
                    <div>
                      <p class="params-t">{{item.typeName == 'LT_跌倒雷达' ? '雷达频率' : '心率'}}</p>
                      <p class="time-t">{{item.typeName == 'LT_跌倒雷达' ? item.ldhz + 'GHZ' : item.bodyHeartRate + '次/分' || '--'}}</p>
                    </div>
                    <div v-if="item.typeName == 'LT_生命体征雷达'">
                      <p class="params-t">体动百分比</p>
                      <p class="time-t">{{item.motionPrecent + '%' || '--'}}</p>
                    </div>
                  </div>
                </div>
                <div class="bottom-item">
                  <span>模组号: {{item.imei || '--'}}</span>
                </div>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizes"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>
        <div class="maskingRight" v-if="changeStatus">
          <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
            <div class="messContainer">
              <div class="cons">
                <device-right-cons :typeId="17" @closeRightCons="closeRightCons"></device-right-cons>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/deviceRadar' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/deviceGas' }">
            <span @click="jumpDev">设备信息</span>
          </el-breadcrumb-item> -->
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei" type="fallRadar"></component>
    </div>
  </div>

  <el-dialog title="设置" :visible.sync="dialogVisible" width="440px">
    <ul class="edit-dialog">
      <li>
        <span class="title">名称</span>
        <el-input placeholder="请输入名称" v-model="editData.name" clearable maxlength="10">
        </el-input>
      </li>
      <li>
        <span class="title">报警条件1</span>
        <el-select v-model="editData.motionAlarmStateType" placeholder="请选择">
          <el-option
            v-for="({value, label}, i) in alarmOptions1"
            :key="i"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
      </li>
      <li>
        <span class="title">报警条件2</span>
        <el-select v-model="editData.stopStateType" placeholder="请选择">
          <el-option
            v-for="({value, label}, i) in alarmOptions2"
            :key="i"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>  
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/components/common/Card'
export default {
  name:'DeviceGas',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons
  },
  data() {
    return {
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
          value: '1',
          label: '在线'
        }, {
          value: '0',
          label: '离线'
        }
      ],
      component: '',
      tabs: [{
        name: '基本信息',
        code: 'BasicInfo'
      }, {
        name: '设备数据',
        code: 'DeviceDatas'
      }, 
      // {
      //   name: '下发命令',
      //   code: 'IssueCommand'
      // },
      {
        name: '报警记录',
        code: 'AlarmRecord'
      }, {
        name: '故障记录',
        code: 'FaultRecord'
      }, {
        name: '安装记录',
        code: 'InstallRecord'
      }],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12,22,32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields:[],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      isMobile: false, // 是否是终端设备
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      dialogVisible: false,
      alarmOptions1: [
        { value: '0', label: '不报警' },
        { value: '1', label: '活跃报警' },
        { value: '2', label: '无人报警' }
      ],
      alarmOptions2: [
        { value: '0', label: '不报警' },
        { value: '1', label: '驻留报警' },
        { value: '2', label: '未驻留报警' }
      ],
      editData: {
        name: '',
        motionAlarmStateType: '0',
        stopStateType: '0'
      },
      editId: null,
    }
  },
  computed: {
    signImg() {
      return (n) => {
        return require(`../../assets/img/bigScreen/sign-${n}.png`)
      }
    },
    titleColor () {
      return ({ removal, alarmStatus }, i) => {
        // let temp = ['#C7C7C7', '#4CC790', '#EE211C']
        let color = removal == '0' ? '#C7C7C7' : alarmStatus  == 'On' ? '#EE211C' : '#4CC790'
        return color
      }
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    this.getDeviceType()
  },
  methods: {
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          // this.treeData.push({
          //   children: [],
          //   id: 'mobile',
          //   label: "终端出库设备",
          //   parentId: 0,
          //   serial: 51,
          //   tenantId: null,
          //   terminalFlag: null,
          //   value: 0
          // })
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.isMobile = item.id == 'mobile'
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data?res.data.data:[]
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId?this.currentTreeId:0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }

      let url = this.params.orgId == -1 ? '/front/device/fallRadar/queryOutbound' : '/front/device/fallRadar/query'
      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            this.dataList = res.data && res.data.map(item => {
              // item.isOnline = '在线'
              // 计算信号 7, 15, 24,31;
              // rssi = csq * 2 - 113
              let csq = (item.rssi + 113) / 2
              if (csq > 0 && csq <= 7) {
                item.sign = 1
              } else if (csq > 7 && csq <= 15) {
                item.sign = 2
              } else if (csq > 15 && csq <= 24) {
                item.sign = 3
              } else if (csq > 24 && csq <= 31) {
                item.sign = 4
              } else {
                item.sign = 0
              }
              return item
            })
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    /**
     * @Description 切换布防or撤防
     * @Author      YOYO     -             2021-10-21
     */
    handleClickSet (item) {
      if (item.isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })
      let { name, deviceId, motionAlarmStateType, stopStateType } = item

      this.dialogVisible = true
      this.editData = {
        id: deviceId,
        name,
        motionAlarmStateType: motionAlarmStateType || '0',
        stopStateType: stopStateType || '0'
      }
    },
    /**
     * @Description 切换布防or撤防
     * @Author      YOYO     -             2021-10-21
     */
    handleSet (type, index, { deviceId, isOnline }) {
      // console.log(type, index)
      if (isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })

      let temp = [
        { text: '撤防', color: '#EE211C', left: '0px', removal: '0' },
        { text: '布防', color: '#4CC790', left: '48px', removal: '1' }
      ]
      // let dom = this.$refs[`active${index}`]

      this.request.get('/front/device/fallRadar/removal', { deviceId, removal: type }).then(res => {

        if (res.code == 200) {
          // dom[0].style = `left: ${temp[type].left};background: ${temp[type].color}`
          // this.dataList[index].removal = temp[type].removal
          this.initData()
          this.$message({ type: 'success', message: '操作成功！' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      })
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 205) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage =1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons(){
      if(!this.changeStatus){
        this.changeStatus = true
        this.showSlid=true
      } else {
        this.showSlid=false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        },440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    handleSave () {
      let { name, motionAlarmStateType, stopStateType, id } = this.editData

      this.request.get(`/front/device/fallRadar/upOne?id=${id}&name=${name}&motionAlarmStateType=${motionAlarmStateType}&stopStateType=${stopStateType}`).then(res => {
        if (res.code == 200) {
          this.dialogVisible = false
          this.initData()
          this.$message({ type: 'success', message: '保存成功' })
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      }).catch(e => {
        this.$message({ type: 'error', message: e })
      })
    },    
  }
};
</script>

<style lang="scss" scoped>
.DeviceListsGas {
  position: relative;
  .devcieContainer{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    h4 {
      padding-bottom: 10px;
    }
    .container {
      padding-left: 260px;
    }
    .query {
      padding-bottom: 10px;
      .queryCons{
        width: 100%;
        overflow: hidden;
        .common{
          float: left;
          margin-bottom: 5px;
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover {
            background: #0774e0;
          }
        }
        .delSome{
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;
          // &:hover{
          //   background: #0774e0;
          // }
          // .imgShow{
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin:10px 6px 0 0;
          //   img{
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }
          //   &.active{
          //     transform: rotate(180deg);
          //   }
          // }
          // span{
          //   float: left;
          //   font-size: 14px;
          //   line-height: 36px;
          // }
        }
      }
    }
    .listsContainer {
      overflow: hidden;
      position: relative;
      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .device-cardList {
          height: 100%;
          width: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 14px;
          display: flex;
          flex-flow: row wrap;
          .device-card {
            position: relative;
            display: inline-block;
            border: 1px solid #E1E1E1;
            background: #fff;
            width: 380px;
            // min-width: 240px;
            height: 300px;
            padding: 5px 10px;
            margin-top: 10px;
            margin-left: 20px;
            h6 {
              height: 28px;
              line-height: 28px;
              border-bottom: 1px solid #E1E1E1;
              overflow: hidden;
              .title {
                font-size: 18px;
                color: #000;
                display: inline-block;
                width: 60%;
              }
              .title-right {
                font-size: 12px;
                float: right;
                color: #178FFD;
                >span {
                  vertical-align: top;

                }

                .sign {
                  margin-right: 2px;
                  vertical-align: 0px;
                  width: 16px;
                }
                .sign-num {
                  margin-right: 5px;
                  vertical-align: 2px;
                }
                .electric {
                  position: relative;
                  top: -2px;
                  display: inline-block;
                  width: 20px;
                  margin-left: 4px;
                  i {
                    position: absolute;
                    top: 11px;
                    left: 1px;
                    // border: 1px solid blue;
                    height: 10px;
                    background-color: #178FFD;
                    &.red {
                      background-color: #F24F4B;
                    }
                  }
                }
                .set {
                  margin-left: 4px;
                  font-size: 20px;
                  cursor: pointer;
                }
              }
            }
            .chart-item {
              // overflow: hidden;
              height: 215px;
              .chart {
                position: relative;
                display: inline-block;
                width: 248px;
                height: 100%;
                vertical-align: top;
                text-align: center;
                .top-title-box {
                  width: 100%;
                  margin: 20px 0 10px;
                  .top-title {
                    display: inline-block;
                    color: #fff;
                    font-size: 13px;
                    background: #C7C7C7;
                    width: 65px;
                    height: 25px;
                    text-align: center;
                    line-height: 25px;
                    border-radius: 4px;
                    margin: 0 3px;
                    &.gray {
                      background: #C7C7C7;
                    }
                    &.red {
                      background: #EE211C;
                    }
                    &.green {
                      background: #4CC790;
                    }
                    img {
                      height: 16px;
                      vertical-align: middle;
                      margin-right: 5px;
                    }
                  }            
                }
                >img {
                  width: 104px;
                  // height: 140px;
                }
                .sizeImg {
                  width: 63px;
                  height: 104px;
                }
                .state {
                  margin: 5px auto;
                  font-size: 13px;
                }
                .switch-box {
                  position: absolute;
                  bottom: 6px;
                  left: 70px;
                  border-radius: 25px;
                  overflow: hidden;
                  line-height: 20px;
                  font-size: 12px;
                  background: #F3F3F3;
                  color: #bbb;
                  .set {
                    cursor: pointer;

                  }
                  span {
                    display: inline-block;
                    width: 50px;
                    text-align: center;
                  }
                  .active {
                    width: 52px;
                    border-radius: 25px;
                    position: absolute;
                    top: 0px;
                    left:0px;
                    color: #fff;
                    background: #EE211C;
                    transition: 0.3s;
                  }
                }
              }
              .device-params {
                display: inline-block;
                width: 130px;
                margin-top: 32px;
                >div {
                  margin-bottom: 10px;
                  color: #333;
                  font-size: 12px;
                  .params-t {
                    display: inline-block;
                    color: #178FFD;
                    border: 1px solid #178FFD;
                    padding: 0px 12px;
                    line-height: 22px;
                    font-size: 13px;
                    font-weight: bold;
                    margin-bottom: 3px;
                  }
                  .address-overtext {
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  // .time-t {
                  //   font-size: 10px;
                  // }
                }
              }
            }
            .bottom-item {
              position: absolute;
              bottom: 0px;
              width: calc(100% - 20px);
              border-top: 1px solid #E1E1E1;
              line-height: 34px;
              text-align: right;
              color: #B4B4B4;
              font-size: 12px;
            }
            &.noOpen {
              h6 {
                // .title {
                //   color: #aaa;
                // }
                .title-right {
                  color: #aaa;
                  .electric i{
                    background-color: #aaa;
                  }
                }
                .set {
                  color: #178FFD
                }
              }
              .chart {
              }
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border: 1px solid #aaa;
                  }
                }                
              }
            }
            &.outItem {
              h6 {
                // .title {
                //   color: #aaa;
                // }
                .title-right {
                  color: #aaa;
                  .electric i{
                    background-color: #aaa;
                  }
                }
              }
              .chart {
                .switch-box {
                  .set {
                    cursor: default;
                  }
                  .active {
                    background-color: #aaa!important;
                  }
                }
              }
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border: 1px solid #aaa;
                  }
                }                
              }
            }
          }
        }
        // .cardList{
        //   height: 100%;
        //   width: 100%;
        //   // overflow-x: hidden;
        //   // overflow-y: auto;
        //   &>li{
        //     float: left;
        //     width: 300px;
        //     height: 240px;
        //     padding: 10px;
        //     box-sizing: border-box;
        //   }
        // }
        // .cardPage {
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 50px;
        //   text-align: center;
        //   padding: 10px 0;
        //   box-sizing: border-box;
        // }
        &.active{
          width: 100%;
          .cardList{
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            &>li{
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }
    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    .navShow {
      overflow: hidden;
      margin-bottom: 10px;
      border-bottom: 1px solid #f2f2f2;
    }
  }
  .edit-dialog {
    li {
      margin-top: 20px;
      .title {
        font-size: 14px;
        color: #333;
        display: inline-block;
        width: 80px;
      }
      .el-input {
        width: 300px;
        line-height: 40px;
        height: 40px;
      }
      .el-select {
        width: 300px;
      }
    }
  }  
  @keyframes slid-open{
      0%{
          transform: translateX(100%);
          opacity: 0;
      }
      100%{
          transform: translateX(0);
      }
  }
  @keyframes slid-out{
      0%{
          width: 600px;
          transform: translateX(0)
      }
      100%{
          transform: translateX(100%)
      }
  }
}
</style><style lang="scss">
.DeviceListsGas {
  .devcieContainer{
    .query {
      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 110px;
        margin-right: 10px;

        .el-input {
          width: 110px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }
    }
    .el-loading-mask{
      background-color: unset;
    }
    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 15px 20px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 20px;
        z-index: 10;
        // left: 30px;
        padding-left: 10px;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: 100%;
        border: 1px solid #ebeef5;
        padding: 40px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .mainContent{
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      color: #7A7D81;
      font-size: 16px;
      font-weight: 500;
    }
    .el-breadcrumb__separator{
      font-size: 16px;
      color: #7A7D81;
      margin: 0 5px;
      font-weight: 500;
    }
    .el-breadcrumb__inner{
      font-size: 16px;
      color: #7A7D81 !important;
      font-weight: 500 !important;
    }
  }
  .el-dialog__header {
    background-color: #1E2639;
    padding: 0;
    .el-dialog__title {
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      margin-left: 22px;
    }
    .el-dialog__headerbtn {
      top: 13px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }  
}
</style>
